import { useState, useContext } from "react";
import { AuthContext } from "../../utils/AuthContext";
import './css/Login.css';
import { jwtDecode } from "jwt-decode";


function Login({ onLogin }) {
  const baseUrl = process.env.REACT_APP_BASE_URL;

  const [username, setUsername] = useState("");
  const [password, setPassword] = useState("");
  const [message, setMessage] = useState({ text: "", type: "" });
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);


  // const allowedDomains = ["men.gov.ma", "taalim.ma"];

  // const isAllowedEmail = (email) => {
  //   if (!email.includes("@")) return false;
  //   const domain = email.split("@").pop().toLowerCase();
  //   return allowedDomains.includes(domain);
  // };


  const { loginMessage } = useContext(AuthContext);

  const handleSubmit = async (e) => {
    e.preventDefault();
    // if (!isAllowedEmail(email)) {
    //   setMessage({ text: "L'adresse email saisie n'est pas valide.", type: "danger" });
    //   return;
    // }
    setLoading(true);
    setMessage({ text: "", type: "" });

    try {
      const response = await fetch(`${baseUrl}/api/auth/login`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password }),
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.message || "Échec de la connexion");
      }

      localStorage.setItem("token", data.token);
      localStorage.setItem("isAuthenticated", "true");
      localStorage.setItem("role", data.role);
      // if (data.token) {
      //   const decoded = jwtDecode(data.token);
      //   if (decoded.modules) {
      //     localStorage.setItem("allowedModules", decoded.modules);
      //   }

      //   const staticModules = [
      //       { id: 1, canRead: true, canWrite: true },
      //       { id: 2, canRead: true, canWrite: true },
      //       { id: 3, canRead: true, canWrite: true },
      //       { id: 4, canRead: true, canWrite: true },
      //       { id: 5, canRead: true, canWrite: true },
      //       { id: 6, canRead: true, canWrite: true },
      //   ];

      //             localStorage.setItem("allowedModules", decoded.modules);

      // }
      const staticModules = [
        { id: 1, canRead: false, canWrite: true },
        { id: 2, canRead: true, canWrite: true },
        { id: 3, canRead: true, canWrite: true },
        { id: 4, canRead: true, canWrite: true },
        { id: 5, canRead: true, canWrite: true },
        { id: 6, canRead: true, canWrite: true },
        { id: 7, canRead: true, canWrite: true }
      ];

      localStorage.setItem("allowedModules", JSON.stringify(staticModules));

      setMessage({ text: "Connexion réussie !", type: "success" });

      setTimeout(() => {
        onLogin();
      }, 1000);
    } catch (error) {
      setMessage({ text: error.message, type: "danger" });
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <div className="login-box">
        <h2 className="login-title">Connexion</h2>

        {(message.text || (typeof loginMessage === "string" && loginMessage)) && (
          <div className={`alert alert-${message.type || "warning"}`} role="alert">
            {message.text || (typeof loginMessage === "string" ? loginMessage : "")}
          </div>
        )}

        <form onSubmit={handleSubmit}>
          <div className="input-wrapper">
            <input
              type="text"
              placeholder="Nom d'utilisateur"
              value={username}
              onChange={(e) => setUsername(e.target.value)}
              required
            />
          </div>

          <div className="input-wrapper password-wrapper">
            <input
              type={showPassword ? "text" : "password"}
              placeholder="Mot de passe"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />

            <span
              className="toggle-password"
              onClick={() => setShowPassword(!showPassword)}
              aria-label="Afficher / masquer le mot de passe"
            >
              <i className={`fa ${showPassword ? "fa-eye-slash" : "fa-eye"}`}></i>
            </span>
          </div>

          <button type="submit" className="login-btn" disabled={loading}>
            {loading ? "Connexion..." : "Se connecter"}
          </button>
        </form>

      </div>
    </div>
  );
}

export default Login;
